<template>
  <div class="eligibility-tool__overlay" role="presentation" @mousedown.self="$emit('close')">
    <section
      ref="dialog"
      class="eligibility-tool__modal"
      role="dialog"
      aria-modal="true"
      aria-label="Contextual offer eligibility checker"
      @keydown="handleKeydown"
    >
      <div class="eligibility-tool__modal-content">
        <slot />
      </div>

      <button
        id="contextual-offers-close-button"
        ref="closeButton"
        class="eligibility-tool__close"
        type="button"
        aria-label="Close eligibility checker"
        @click="$emit('close')"
      >
        <span aria-hidden="true">×</span>
      </button>
    </section>
  </div>
</template>

<script>
const FOCUSABLE_SELECTOR = [
  'a[href]',
  'area[href]',
  'button:not([disabled])',
  'input:not([disabled])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  '[tabindex]:not([tabindex="-1"])'
].join(',');

export default {
  name: 'EligibilityModal',
  mounted() {
    this.previouslyFocusedElement = document.activeElement;
    document.addEventListener('keydown', this.handleKeyboardMode, true);
    document.addEventListener('mousedown', this.handlePointerMode, true);
    document.body.classList.add('eligibility-tool-modal-open');
    this.$nextTick(this.focusInitialElement);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeyboardMode, true);
    document.removeEventListener('mousedown', this.handlePointerMode, true);
    document.body.classList.remove('eligibility-tool-modal-open');
    if (this.previouslyFocusedElement && typeof this.previouslyFocusedElement.focus === 'function') {
      this.previouslyFocusedElement.focus();
    }
  },
  methods: {
    handleKeyboardMode(event) {
      if (event.key === 'Tab') document.body.classList.add('eligibility-tool--keyboard');
    },
    handlePointerMode() { document.body.classList.remove('eligibility-tool--keyboard'); },
    getFocusableElements() {
      return Array.from(this.$refs.dialog.querySelectorAll(FOCUSABLE_SELECTOR))
        .filter((element) => element.offsetParent !== null || element === document.activeElement);
    },
    focusInitialElement() {
      const heading = this.$refs.dialog.querySelector('[data-modal-heading]');
      if (heading && typeof heading.focus === 'function') {
        heading.focus({ preventScroll: true });
        return;
      }
      const focusable = this.getFocusableElements();
      if (focusable.length) focusable[0].focus({ preventScroll: true });
    },
    handleKeydown(event) {
      if (event.key === 'Escape' || event.key === 'Esc') {
        event.preventDefault();
        this.$emit('close');
        return;
      }

      if (event.key !== 'Tab') return;

      const focusable = this.getFocusableElements();
      if (!focusable.length) {
        event.preventDefault();
        this.$refs.dialog.focus();
        return;
      }

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }
};
</script>
